// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3n25-","description":"PatientConsentPreview_description__11sWJ"};